export const findPdfName = (element: HTMLElement, pdfUrl: string): string | undefined => {
  if (element) {
    const link = element.querySelector<HTMLAnchorElement>(`a[href="${pdfUrl}"]`)
    return link?.querySelector('.attach__name')?.textContent ?? undefined
  }

  return undefined
}
